module.exports = __webpack_public_path__ + "img/robot.8a949f36.svg";